import Examinations from './Examinations';

export default Examinations;
